import { numberWithCommas } from "./numberWithCommas";

export const DEFAULT_SMALL_COUNT_THRESHOLD = 50;

export function suppressedCountLabel(
  threshold: number | null | undefined = DEFAULT_SMALL_COUNT_THRESHOLD,
): string {
  return `<${threshold ?? DEFAULT_SMALL_COUNT_THRESHOLD}`;
}

export function formatCount(
  value: number | string | null | undefined,
  suppressed?: boolean | null,
  threshold?: number | null,
): string {
  if (suppressed) {
    return suppressedCountLabel(threshold);
  }
  return numberWithCommas(value);
}
